import { useState, useCallback } from "react";
import { httpsCallable } from "@firebase/functions";
import { functions } from "../../../firebaseConfig";
import { HttpsCallableResult } from "@firebase/functions-types";

type OrderBookEntry = {
  rank: number;
  principle: number;
  created?: string;
  started?: string;
};

export const useGetOrderBook = () => {
  const [loadingOrderBook, setLoadingOrderBook] = useState<boolean>(false);
  const [orderBookError, setOrderBookError] = useState<string | null>(null);
  const [orderBook, setOrderBook] = useState<OrderBookEntry[] | undefined>(
    undefined,
  );
  const [recentActiveLoans, setRecentActiveLoans] = useState<
    OrderBookEntry[] | undefined
  >(undefined);

  const fetchOrderBook = httpsCallable(functions, "fetchOrderBook");

  const getOrderBook = useCallback(
    async (request: { collectionSymbol: string }) => {
      setLoadingOrderBook(true);
      try {
        const response: HttpsCallableResult = await fetchOrderBook(request);
        const responseData = response.data as {
          bestOffers: OrderBookEntry[];
          recentActiveLoans: OrderBookEntry[];
        };
        setOrderBook(responseData.bestOffers);
        setRecentActiveLoans(responseData.recentActiveLoans);
        setOrderBookError(null);
      } catch (err) {
        if (err instanceof Error) {
          setOrderBookError(err.message);
        } else {
          setOrderBookError("An unexpected error occurred.");
        }
        setOrderBook(undefined);
      } finally {
        setLoadingOrderBook(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return {
    getOrderBook,
    loadingOrderBook,
    orderBook,
    recentActiveLoans,
    orderBookError,
  };
};
